class SpeakerRelations {
    constructor({eventId = "", subEventId = "", sessionId}) {
        (this.eventId = eventId || ""),
            (this.subEventId = subEventId || ""),
            (this.sessionId = sessionId || "");
    }

    static fromObject(speakerRelations){
        return new SpeakerRelations({
            eventId: speakerRelations.eventId || "",
            subEventId: speakerRelations.subEventId || "",
            sessionId: speakerRelations.sessionId || "",
        });
    }

    toObject(){
        return {
            eventId: this.eventId || "",
            subEventId: this.subEventId || "",
            sessionId: this.sessionId || "",
        }
    }

}

export default SpeakerRelations;